import { Stepper } from "shared/app/InviteAndCreateModal/slices/InviteApplicants/components/Stepper";
import { Step } from "views/settings-integration/components/AddIntegrationModal/types";

const STEP_TITLES: Record<Step, string> = {
  [Step.FIRST]: "Choose integration",
  [Step.SECOND]: "Add credentials"
};

interface HeaderProps {
  currentStep: Step;
}

export const Header = ({ currentStep }: HeaderProps) => (
  <>
    <h1 className="font-bold text-xl">{STEP_TITLES[currentStep]}</h1>
    <div className="my-6">
      <Stepper currentStepIdx={Number(currentStep)} totalSteps={2} />
    </div>
  </>
);
